import { render, staticRenderFns } from "./MultiBetSlip.vue?vue&type=template&id=62bf7041&scoped=true&"
import script from "./MultiBetSlip.vue?vue&type=script&lang=js&"
export * from "./MultiBetSlip.vue?vue&type=script&lang=js&"
import style0 from "./MultiBetSlip.vue?vue&type=style&index=0&id=62bf7041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf7041",
  null
  
)

export default component.exports